export class ServerParameterModel {
    parameterName: string;
    parameterValue: any;
}


// WEBPACK FOOTER //
// ./src/app/_models/server-parameter.model.ts